import React from "react"
import Home from "./Home"
import * as contentful from "contentful"
import "./styles/main.css"
import "./App.css"

const client = contentful.createClient({
  accessToken: "g8oV2FoztE-NIyNvLD6mfYGR7gzmNM5QYJx_dPvE2qU",
  space: "8rd48v4ud6k0"
})

function App() {
  return (
    <div>
      <Home
        client={client}
        headerId="v7dxKyzLfhuUfWejCBagO"
        contentId="4ZW3dgq0cFYslW5uGrAmEH"
      />
    </div>
  )
}

export default App
